import { Card, Tabs } from 'antd';
import { ReactNode, useMemo, useState } from 'react';

import { DocumentMultiReceiptEntity, DocumentReceiptEntity } from '../../../generated-api';
import ocrTypeNameDefinitions from '../../../utils/ocrTypeNameDefinitions';
import ReceiptTable from '../Receipt/ReceiptTable';
import { ReceiptFormInput } from './receiptResultPageDefinition';
import { FormComponentProps, OcrResultPageDefinition, ResultPageDocument } from './types';

const { TabPane } = Tabs;

function MultiReceiptFormComponent({ entity }: FormComponentProps<DocumentMultiReceiptEntity>) {
  const [tab, setTab] = useState('0');
  const formEntities: DocumentReceiptEntity[] = useMemo(
    () =>
      entity.receipts.map((receipt) => ({
        type: receipt.type,
        payment_date: receipt.payment_date,
        payee: receipt.payee,
        business_number: receipt.business_number,
        receipt_details: receipt.receipt_details,
      })),
    [entity.receipts]
  );

  return (
    <>
      <Tabs defaultActiveKey={tab} onChange={setTab}>
        {formEntities.map((form, index) => (
          <TabPane key={index} forceRender tab={index + 1} tabKey={index.toString()}>
            <ReceiptFormInput entity={form} />
          </TabPane>
        ))}
      </Tabs>
    </>
  );
}

function expandMultiReceiptTable(record: ResultPageDocument<DocumentMultiReceiptEntity>): ReactNode {
  if (record.error) {
    return;
  }
  return (
    <>
      {record.latest_revision.receipts.map((receipt, receiptIndex) => (
        <Card key={receiptIndex}>
          <ReceiptTable receipt={receipt} />
        </Card>
      ))}
    </>
  );
}

const multiReceiptResultPageDefinition: OcrResultPageDefinition<DocumentMultiReceiptEntity> = {
  name: ocrTypeNameDefinitions.multi_receipt,
  tableColumns: [],
  tableExpandable: {
    expandedRowRender: expandMultiReceiptTable,
  },
  formComponent: MultiReceiptFormComponent,
};

export default multiReceiptResultPageDefinition;
